// extracted by mini-css-extract-plugin
export default {"root":"VATCalculator_root__PtDCe","sub-text":"VATCalculator_sub-text__U8Lbm","edit-button":"VATCalculator_edit-button__GXr5F","inline-input":"VATCalculator_inline-input__1f8H2"};